import { ALLOW_ADMIN_EDITING, IS_ADMIN_USER, ROLES, SAP_TOKEN } from "../../../ducks/login";
import {
  CHANGE_STATUS_SURVEY_CONFIRM_DIALOG,
  changeStatusOfSurveyProperty,
  DISABLE_SENT_BUTTON,
  loadAvailableWorkflowTransition,
  POSSIBLE_TRANSITIONS,
  SHOW_CHANGE_STATUS_SURVEY_DIALOG,
  SHOW_SEND_SURVEY_DIALOG
} from "../../../ducks/statusOfSurvey";
import {
  CURRENT_OVERVIEW,
  DETAILS,
  propertyChange,
  REFRESH_DETAILS_PAGE,
  RESPONDENT,
  RESPONDENT_LIST,
  respondentForPagePropertyChange,
  SORT_TABLE_TEMPLATE,
  SORT_TABLE_TEMPLATE_ASCENDING,
  SORT_TABLE_TEMPLATE_BY,
  sortColumn
} from "../../../ducks/respondentsOverview";
import { EDITING_DISABLED, SURVEY_RESULT, TRIGGER_STATE } from "../../../ducks/surveyView";
import { LOADED, loadSurveyVersion, SURVEY_NAME, SURVEY_TEMPLATE } from "../../../ducks/survey";
import {
  hideReadOnlyDialog,
  loadSurveyResult,
  LOCK_BY_USER,
  LOCK_FROM,
  lockInfoOfSurvey,
  READ_ONLY,
  SHOW_READ_ONLY_DIALOG
} from "../../../ducks/surveyRunner";
import { changeProperty, loadTempUsers, SHOW_TEMP_USER_DIALOG } from "../../../ducks/manageSurveyTempUsers";

import RespondentDetails from "./RespondentDetails";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showDialog } from "../../../ducks/confirmDialog";

const mapStateToProps = (state) => {
  return {
    details: state.respondentsOverview[DETAILS],
    currentOverview: state.respondentsOverview[CURRENT_OVERVIEW],
    sortTableTemplate: state.respondentsOverview[SORT_TABLE_TEMPLATE],
    sortTableTemplateBy: state.respondentsOverview[SORT_TABLE_TEMPLATE_BY],
    sortTableTemplateAscending: state.respondentsOverview[SORT_TABLE_TEMPLATE_ASCENDING],
    showTempUserDialog: state.manageSurveyTempUsers[SHOW_TEMP_USER_DIALOG],
    respondent: state.respondentsOverview[RESPONDENT],
    respondentList: state.respondentsOverview[RESPONDENT_LIST],
    refreshDetailsPage: state.respondentsOverview[REFRESH_DETAILS_PAGE],
    surveyResult: state.surveyView[SURVEY_RESULT],
    surveyTemplate: state.survey[SURVEY_TEMPLATE],
    showSendSurveyDialog: state.statusOfSurvey[SHOW_SEND_SURVEY_DIALOG],
    changeStatusSurveyConfirmDialog: state.statusOfSurvey[CHANGE_STATUS_SURVEY_CONFIRM_DIALOG],
    showChangeStatusSurveyDialog: state.statusOfSurvey[SHOW_CHANGE_STATUS_SURVEY_DIALOG],
    disableSentButton: state.statusOfSurvey[DISABLE_SENT_BUTTON],
    role: state.login[ROLES],
    sapToken: state.login[SAP_TOKEN],
    isAdminUser: state.login[IS_ADMIN_USER],
    allowAdminEditing: state.login[ALLOW_ADMIN_EDITING],
    triggerState: state.surveyView[TRIGGER_STATE],
    editingDisabled: state.surveyView[EDITING_DISABLED],
    possibleTransitions: state.statusOfSurvey[POSSIBLE_TRANSITIONS],
    readOnly: state.surveyRunner[READ_ONLY],
    showReadOnlyDialog: state.surveyRunner[SHOW_READ_ONLY_DIALOG],
    lockByUser: state.surveyRunner[LOCK_BY_USER],
    lockFrom: state.surveyRunner[LOCK_FROM],
    surveyName: state.survey[SURVEY_NAME],
    [LOADED]: state.survey[LOADED]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      showDialog,
      sortColumn,
      loadSurveyVersion,
      propertyChange,
      respondentForPagePropertyChange,
      changeProperty,
      loadTempUsers,
      loadSurveyResult,
      changeStatusOfSurveyProperty,
      loadAvailableWorkflowTransition,
      hideReadOnlyDialog,
      lockInfoOfSurvey
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RespondentDetails);
